export default {
  data: {
    historical_timeline: [],
    days_ago: 0,
    uptime_percentage: 0,
    dead_tokens_now: null,
  },
  error: false,
};
